import React from 'react';
import {
  LedgerHeader,
  ledgerContainerClass,
  type LedgerCollapse,
  type LedgerColumn,
} from '@billda/design-system';
import type { SiteListItem } from '@billda/api';
import { SiteListItem as SiteListItemComponent } from '../molecules/SiteListItem';
import { ListViewShell } from '../../../../../shared/components/ui/ListViewShell';

interface SitesListViewProps {
  sites: SiteListItem[];
  loading: boolean;
  onItemClick: (siteId: number) => void;
}

const SITE_COLLAPSE: LedgerCollapse = {
  container: 'sites-collection',
  at: 620,
};

const SITE_COLUMNS: LedgerColumn[] = [
  { key: 'plots', label: 'Plots', flex: 0.8 },
  { key: 'value', label: 'Value', flex: 1 },
  { key: 'progress', label: 'Progress', flex: 1.25 },
];

export const SitesListView: React.FC<SitesListViewProps> = ({
  sites,
  loading,
  onItemClick,
}) => {
  return (
    <div className={ledgerContainerClass(SITE_COLLAPSE.container)}>
      <ListViewShell
        itemCount={sites.length}
        loading={loading}
        emptyMessage="No sites found"
      >
        <LedgerHeader
          columns={SITE_COLUMNS}
          collapse={SITE_COLLAPSE}
          titleLabel="Name"
          showValues={false}
          showActions
          hideBelow={SITE_COLLAPSE.at}
        />
        {sites.map(site => (
          <SiteListItemComponent
            key={site.id}
            site={site}
            columns={SITE_COLUMNS}
            collapse={SITE_COLLAPSE}
            onClick={onItemClick}
          />
        ))}
      </ListViewShell>
    </div>
  );
};
